import { render, staticRenderFns } from "./rearMain.vue?vue&type=template&id=6c80483c&"
import script from "./rearMain.vue?vue&type=script&lang=js&"
export * from "./rearMain.vue?vue&type=script&lang=js&"
import style0 from "./rearMain.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports